import { gql } from "@apollo/client";

// Get all positions
export const GET_POSITIONS = gql`
  query GetPositions {
    positions {
      id
      tradeId
      type
      quantity
      price
      date
      notes
      status
      createdAt
      updatedAt
      trade {
        id
        symbol
        date
        side
        quantity
        price
        notes
      }
    }
  }
`;

// Get a single position
export const GET_POSITION = gql`
  query GetPosition($id: String!) {
    position(id: $id) {
      id
      tradeId
      type
      quantity
      price
      date
      notes
      status
      createdAt
      updatedAt
      trade {
        id
        symbol
        date
        side
        quantity
        price
        notes
      }
    }
  }
`;

// Create a position
export const CREATE_POSITION = gql`
  mutation CreatePosition($createPositionInput: CreatePositionInput!) {
    createPosition(createPositionInput: $createPositionInput) {
      id
      tradeId
      type
      quantity
      price
      date
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

// Update a position
export const UPDATE_POSITION = gql`
  mutation UpdatePosition(
    $id: String!
    $updatePositionInput: UpdatePositionInput!
  ) {
    updatePosition(id: $id, updatePositionInput: $updatePositionInput) {
      id
      tradeId
      type
      quantity
      price
      date
      notes
      status
    }
  }
`;

// Delete a position
export const REMOVE_POSITION = gql`
  mutation RemovePosition($id: String!) {
    removePosition(id: $id) {
      id
      tradeId
    }
  }
`;

export const AVERAGE_COST_BASIS = gql`
  query AverageCostBasis($tradeId: Int!) {
    averageCostBasis(tradeId: $tradeId) {
      averageCostBasis
      totalQuantity
      totalCost
    }
  }
`;

export const CALCULATE_PROFIT_LOSS = gql`
  query CalculateProfitLoss(
    $tradeId: Int!
    $exitQuantity: Int!
    $exitPrice: Float!
  ) {
    calculateProfitLoss(
      tradeId: $tradeId
      exitQuantity: $exitQuantity
      exitPrice: $exitPrice
    ) {
      averageCostBasis
      totalQuantity
      totalCost
    }
  }
`;

// Get market data for a trade (used in position form)
export const GET_TRADE_MARKET_DATA = gql`
  query GetTradeMarketData($tradeId: Int!) {
    trade(id: $tradeId) {
      id
      symbol
      marketContext {
        currentPrice
        hasMarketData
      }
    }
  }
`;

// Get market quote by symbol (backend proxy)
export const GET_MARKET_QUOTE = gql`
  query MarketQuote($symbol: String!) {
    marketQuote(symbol: $symbol) {
      currentPrice
      hasMarketData
      priceChange
      priceChangePercent
      lastUpdated
      companyInfo {
        name
        description
        sector
        industry
      }
      availableIndicators
    }
  }
`;
